import { render, staticRenderFns } from "./VUpload.vue?vue&type=template&id=6a79bdda&scoped=true&lang=pug"
import script from "./VUpload.vue?vue&type=script&lang=js"
export * from "./VUpload.vue?vue&type=script&lang=js"
import style0 from "./VUpload.vue?vue&type=style&index=0&id=6a79bdda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a79bdda",
  null
  
)

export default component.exports